const ChartInnerTextPlugin = {
  id: "chartInnerTextPlugin",
  defaults: {
    chartInnerTextPlugin: {
      percentage: false,
      text: [],
    },
  },
  afterDatasetDraw(chart, args, options) {
    const config = options.chartInnerTextPlugin;
    const { ctx } = chart;
    const meta = args.meta;
    if (meta.data.length == 0) {
      return;
    }
    const xCenter = meta.data[0].x;
    const yCenter = meta.data[0].y;
    if (config.percentage) {
      this.drawPercentage(ctx, xCenter, yCenter, chart);
    } else if (config.text != null && config.text.length > 0) {
      this.drawText(ctx, xCenter, yCenter, config.text, "#000");
    }
  },
  drawPercentage(ctx, xCenter, yCenter, chart) {
    const dataset = chart.data.datasets[0].data;
    const total = dataset.reduce((sum, value) => sum + value, 0);
    const finalValue = total > 0 ? (dataset[0] / total) * 100 : 0;

    const chartWidth = chart.width;
    const chartHeight = chart.height;
    const fontSize = Math.min(chartWidth, chartHeight) * 0.15; // Adjust 0.15 as needed for desired scaling

    // Animation logic
    if (!this.startTime) {
      this.startTime = performance.now(); // Start time of animation
    }

    const duration = 1300; // Animation duration in milliseconds
    const now = performance.now();
    const elapsedTime = now - this.startTime;

    if (elapsedTime < duration) {
      const progress = elapsedTime / duration;
      this.currentValue = progress * finalValue;
      requestAnimationFrame(() => chart.draw()); // Request another frame to keep animating
    } else {
      this.currentValue = finalValue; // Set final value after the duration
    }

    const displayValue = this.currentValue.toFixed(0) + "%";
    const text: Array<IInnerChartText> = [{ value: displayValue, bold: true, fontSize: fontSize }];

    this.drawText(ctx, xCenter, yCenter, text, "#00A3E0");
  },
  drawText(ctx, xCenter, yCenter, text, style) {
    const defaultMargin = 2;

    const totalHeight = text.reduce((part, x) => part + defaultMargin + this.calculateFontSize(x.fontSize), 0);
    let currentY = yCenter + this.calculateFontSize(text[0].fontSize) - totalHeight / 2;

    ctx.textAlign = "center";
    ctx.fillStyle = style;

    text.forEach((textObject: IInnerChartText) => {
      let currentX = xCenter;
      ctx.font = `${textObject.bold ? "bold " : ""}${this.calculateFontSize(textObject.fontSize)}px Ubuntu`;

      const partWidth = ctx.measureText(textObject.value).width;
      ctx.fillText(textObject.value, currentX, currentY);
      currentX += partWidth / 2;
      currentY += defaultMargin + this.calculateFontSize(textObject.fontSize);
    });
  },
  calculateFontSize(size: number | null) {
    const defaultFontSize = 14;
    return size && size !== 0 ? size : defaultFontSize;
  },
};

export default ChartInnerTextPlugin;
